import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchFacets } from '@app/src/api/fetchHooks'
import { useAuthentication } from '@app/src/context/AuthenticationContext'
import useSignalRListener from '@app/src/hooks/signalRListener'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import paths from '@app/src/wf-constants/paths'
import { Notifications, NotificationsOutlined } from '@mui/icons-material'
import { Badge, IconButton, Tooltip } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { useIntl } from 'react-intl'
import { generatePath, useLocation } from 'react-router'
import { Link } from 'react-router-dom'

const NotificationsMenuItem: React.FC = () => {
  const { formatMessage } = useIntl()
  const notificationsPath = generatePath(paths.notifications)
  const { pathname } = useLocation()

  const { scope } = useAuthentication()
  const queryClient = useQueryClient()

  const {
    facets: [unseenNotifications],
  } = useFetchFacets({
    endpoint: endpoints.notificationsWithFacets,
    filter: [{ name: 'seen', filters: [{ operator: Operators.EqualTo, value: false }] }],
    facetsParam: [{ name: 'seen', isEnum: true }],
    key: [FetchKey.Notification, FetchKey.NotificationFacets],
    options: {
      enabled: Boolean(scope.solution && scope.solution !== 'default'),
    },
  })

  useSignalRListener('Notification', () => {
    queryClient.invalidateQueries({ queryKey: [FetchKey.Notification] })
  })

  const isSelected = pathname.includes(notificationsPath)

  return (
    <Tooltip arrow title={formatMessage({ id: 'resourceTypes.notification' })}>
      <IconButton size="medium" component={Link} to={notificationsPath}>
        <Badge
          badgeContent={unseenNotifications?.[0]?.count}
          max={99}
          overlap="circular"
          sx={{ '& .MuiBadge-badge': { backgroundColor: 'semantic.error', color: 'white' } }}
        >
          {isSelected ? (
            <Notifications fontSize="medium" color="primary" />
          ) : (
            <NotificationsOutlined fontSize="medium" />
          )}
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

export default NotificationsMenuItem
